import CustomDialog from "./customDialog.container";

export default CustomDialog;
